import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Rating from "./Rating";

function ProductCard({ product }) {
  return (
    <Card className="my-3 p-3 rounded">
      <Link to={`/product/${product._id}`}>
        <Card.Img variant="top" src={product.image} />
      </Link>
      <Card.Body>
        <Link to={`/product/${product._id}`}>
          <Card.Title as="div" className="product-title">
            <strong>{product.name}</strong>
          </Card.Title>
        </Link>
        <Card.Text as="p">
          {product.description.substring(0, 50)}...
        </Card.Text>
        <Card.Text as='h3'>#{product.price}</Card.Text>
        <Card.Text as='div'>
          <Rating value={product.rating} text={`${product.numReviews}reviews`}/>
        </Card.Text>

      </Card.Body>
    </Card>
  );
}

export default ProductCard;
